import Button from '@sdk/components/ui/buttons/Button';
import ProgressButton from '@sdk/components/ui/buttons/ProgressButton';
import gettext from '@sdk/lang/gettext';
import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import {
  FooterRegularButtonWrapper,
  Footer,
} from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/timesheetViewModalFooter.styles';
import DenyButton from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalFooter/DenyButton/DenyButton';

type Props = {
  deny: (reason: string) => Promise<void>;
  approve: () => Promise<void>;
  close: VoidFunction;
  status: TimesheetStatus;
};
const ModalFooter = ({ deny, approve, close, status }: Props) => {
  if (status === TimesheetStatus.pendingConsent) {
    return (
      <Footer>
        <FooterRegularButtonWrapper>
          <DenyButton deny={deny} />
        </FooterRegularButtonWrapper>

        <FooterRegularButtonWrapper mLeft={10}>
          <ProgressButton buttonType={ButtonType.success} onClick={approve}>
            {gettext('Approve')}
          </ProgressButton>
        </FooterRegularButtonWrapper>
      </Footer>
    );
  }

  return (
    <Footer>
      <FooterRegularButtonWrapper>
        <Button onClick={close}>{gettext('Close')}</Button>
      </FooterRegularButtonWrapper>
    </Footer>
  );
};

export default ModalFooter;
